import dataService from 'services/dataService';
import { apiGetClinicSelectOptions } from 'services/dataService/resources';

const ITEMS_PER_REQUEST = 100;

/**
 * Loads a page of clinic options for async select boxes from the paginated
 * `core/clinics/select-options` endpoint.
 *
 * Only guid/legalname are returned. When a picked clinic's details are needed
 * (address, city, state...) fetch them separately via `apiGetClinicByGuid`.
 */
const loadClinicOptions = async (search, page = 1) => {
  try {
    const { data } = await dataService.getList(
      apiGetClinicSelectOptions({
        search,
        page,
        items: ITEMS_PER_REQUEST,
      }),
    );

    if (!data?.items) return { options: [], hasMore: false };

    const options = data.items.map(({ guid, label }) => ({
      id: guid,
      value: guid,
      label,
    }));

    return {
      options,
      hasMore: page * ITEMS_PER_REQUEST < (data.count ?? 0),
    };
  } catch (error) {
    return { options: [], hasMore: false };
  }
};

export default loadClinicOptions;
